var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"farm-empty",on:{"click":_vm.emitClick}},[_c('agro-icons',{attrs:{"name":"agriculture","color":"rgba(0, 252, 161, 0.2)","size":"22"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }